import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../styles/pages.css";
import { getPortfolio } from "../../api";
import { Image } from 'antd';

const EnPortfolioDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [portfolio, setPortfolio] = useState(null);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      (async () => {
        const res = await getPortfolio({ id: id });
        const data = res.data;
        setPortfolio(data);
      })();
      setLoading(false);
    }, 100);
  }, [id]);

  const handleBackToList = () => {
    navigate("/en/portfolio");
  };

  if (loading) {
    return <div className="loading">loading...</div>;
  }

  if (!portfolio) {
    return <div className="not-found">Cannot find items.</div>;
  }

  return (
    <div className="portfolio-detail-container">
      <div className="portfolio-detail-content">
        <h1 className="portfolio-detail-title">{portfolio.en_translations[0].title_en}</h1>
        <div className="portfolio-info-grid">
          <div className="portfolio-specs">
            <table className="specs-table">
              <tbody>
                <tr>
                  <th>Category</th>
                  <td>{portfolio.portfolio_en_category || "Construction Work"}</td>
                </tr>
                <tr>
                  <th>Content</th>
                  <td>{portfolio.en_translations[0].content_en}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="portfolio-image-container">
          {portfolio.photos.map((image) => (
            <div key={image.id} className="portfolio-detail-image-container">
              <Image src={image.file.url} alt={`${portfolio.title} 이미지 ${image.id}`} className="portfolio-detail-image" />
            </div>
          ))}
        </div>

        <div className="portfolio-list-button-container">
          <button className="portfolio-list-button" onClick={handleBackToList}>
            on the list
            <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="74.318" height="9.143" viewBox="0 0 74.318 9.143">
              <path data-name="패스 17" d="M7734.385 1613.134h72.855l-10.653-8.248" transform="translate(-7734.385 -1604.491)" style={{ fill: "none", stroke: "currentColor" }} />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnPortfolioDetail;
